// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__RNc8e","title":"FrontImage_title__3I_-L"};